'use client'
import Image from "next/image";
import GetInstantQuoteButton from "@/components/Contact/GetInstantQuote";
import React from "react";

const GetQuteTip=({tip}:{ tip: string })=> {
	return <div className="container flex max-md:flex-col justify-between my-10 items-center gap-2 max-md:gap-4">
		<Image
			src="/image/service/tips.png"
			width={25}
			height={20}
			alt="material Selection bottom"
			quality={100}
			className="w-[25] h-[24] object-cover"
		></Image>
		{/*<BulbOutlined className="!text-themeWarning500 font-bold text-3xl" />*/}
		<div className="text-[15px] font-bold text-center">
			{tip}
		</div>
		<GetInstantQuoteButton></GetInstantQuoteButton>
	</div>
}
export default GetQuteTip
